/**
 * APIの電文を表すクラスです．全てのRequest, Responseオブジェクトが継承する必要があります．
 */
export abstract class AbstractResponse {
  /** 継承したクラスの名前を返却する。モック起動の際に ApiClient が使用する */
  abstract telegramId(): string
}
